import { ref, type Ref } from "vue"

const openRef: Ref<boolean> = ref(false)

export function useUploadDialogState(): { isOpen: Ref<boolean>; open: () => void; close: () => void; toggle: () => void } {
  return {
    isOpen: openRef,
    open: () => { openRef.value = true },
    close: () => { openRef.value = false },
    toggle: () => { openRef.value = !openRef.value }
  }
}
